import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    ViewAll: {
        id: 'Practice.Components.ViewAll',
        defaultMessage: 'view all',
    },
});
